// extracted by mini-css-extract-plugin
export default {"wrap":"eJ-z","articleImagesWrap":"fJ-z","articleImage":"gJ-z","singleImage":"hJ-z"};